import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';

import styles from './EditCardDetailsForm.module.scss';

type Props = {
  renderPaymentMethod?: () => React.JSX.Element | null;
  submitting: boolean;
  onCancel: () => void;
};

const EditCardDetailsForm: React.FC<Props> = ({ renderPaymentMethod, submitting, onCancel }) => {
  const { t } = useTranslation(['common', 'user']);
  return (
    <div>
      <div className={styles.title}>
        <h1>{t('user:payment.add_card_details')}</h1>
      </div>
      <div>{renderPaymentMethod ? renderPaymentMethod() : null}</div>
      <Button onClick={onCancel} className={styles.cancelButton} fullWidth label={t('common:confirmation_dialog.close')} />
      {submitting && <LoadingOverlay transparentBackground inline />}
    </div>
  );
};

export default EditCardDetailsForm;
